import { COLOR_MAP } from "./ColorNames";

export const MULTIPLE_FOLLOW_UP = [
  {
    subject: '@candidate_full_name Following Up !',
    mail: `Hi @candidate_full_name </br>This is a follow-up mail regarding the role we shared with you few days earlier. The hiring manager has specifically liked your profile; hence, we are checking with you to see if you could be available for an interview.</br> If interested, please apply or reply to this email for our talent acquisition team to reach out to you immediately for the first round of discussion.`,
    selectedFollowUPdays: 1
  },
  {
    subject:'Following up @candidate_full_name',
    mail: 'Hi @candidate_full_name </br>This is a second follow-up mail regarding the role we shared with you earlier. The interview processes is almost over since your profile has been shortlisted by the hiring manager; hence, we are reaching out to you for a quick check, if you would be interested in an interview call.</br> If interested, please apply or reply to this email for our talent acquisition team to reach out to you immediately for the first round of discussion.',
    selectedFollowUPdays: 1
  }
]

export const placeholderMapping: { [text: string]: string } = {
  "@fullName:": `<span style='border: 0.1rem solid ${COLOR_MAP.GREEN}; border-radius:4px;' contenteditable = 'false'>@fullName</span> `,
  "@candidate_full_name:": `<span style='border: 0.1rem solid ${COLOR_MAP.GREEN}; border-radius:4px;' contenteditable = 'false'>@candidate_full_name</span> `,
  "@candidate_current_location:": `<span style='border: 0.1rem solid ${COLOR_MAP.GREEN}; border-radius:4px' contenteditable = 'false' >@candidate_current_location</span> `,
  "@candidate_industry:": `<span style='border: 0.1rem solid ${COLOR_MAP.GREEN}; border-radius:4px' contenteditable = 'false'>@candidate_industry</span> `,
  "@candidate_role:": `<span style='border: 0.1rem solid ${COLOR_MAP.GREEN}; border-radius:4px' contenteditable = 'false'>@candidate_role</span> `,
  "@candidate_key_skills:": `<span style='border: 0.1rem solid ${COLOR_MAP.GREEN}; border-radius:4px' contenteditable = 'false'>@candidate_key_skills</span> `,
  "@candidate_education:": `<span style='border: 0.1rem solid ${COLOR_MAP.GREEN}; border-radius:4px' contenteditable = 'false'>@candidate_education</span> `,
  "@company_name:": `<span style='border: 0.1rem solid ${COLOR_MAP.GREEN}; border-radius:4px' contenteditable = 'false'>@company_name</span> `,
};


export const currencyList = [
  {label : 'INR', value : 'INR'},
  {label : 'SGD', value : 'SGD'},
  {label : 'MYR', value : 'MYR'},
  {label : 'HKD', value : 'HKD'},
  {label : 'IDR', value : 'IDR'},
  {label : 'PHP', value : 'PHP'},
  {label : 'THB', value : 'THB'},
  {label : 'VND', value : 'VND'},
  { label: 'Dirhams', value: 'Dirhams' },
  { label: 'Bahraini Dirhams', value: 'Bahraini Dirhams' },
  { label: 'Jordanian Dinars', value: 'Jordanian Dinars' },
  { label: 'Kuwaiti Dinars', value: 'Kuwaiti Dinars' },
  { label: 'Lebanese Pounds', value: 'Lebanese Pounds' },
  { label: 'Omani Riyals', value: 'Omani Riyals' },
  { label: 'Pataca', value: 'Pataca' },
  { label: 'Qatari Riyals', value: 'Qatari Riyals' },
  { label: 'Saudi Riyals', value: 'Saudi Riyals' },
  { label: 'US Dollar', value: 'US Dollar' },
  { label: 'Yuan Renminbi', value: 'Yuan Renminbi' }
]

export const SALARY_RANGE = [
  {
    label: '0',
    value: '0'
  },
  {
    label: '100000',
    value: '100000'
  },
  {
    label: '200000',
    value: '200000'
  },
  {
    label: '300000',
    value: '300000'
  },
  {
    label: '400000',
    value: '400000'
  },
  {
    label: '500000',
    value: '500000'
  },
  {
    label: '600000',
    value: '600000'
  },
  {
    label: '700000',
    value: '700000'
  },
  {
    label: '800000',
    value: '800000'
  },
  {
    label: '900000',
    value: '900000'
  },
  {
    label: '1000000',
    value: '1000000'
  },
  {
    label: '1100000',
    value: '1100000'
  },
  {
    label: '1200000',
    value: '1200000'
  },
  {
    label: '1300000',
    value: '1300000'
  },
  {
    label: '1400000',
    value: '1400000'
  },
  {
    label: '1500000',
    value: '1500000'
  },
  {
    label: '1600000',
    value: '1600000'
  },
  {
    label: '1700000',
    value: '1700000'
  },
  {
    label: '1800000',
    value: '1800000'
  },
  {
    label: '1900000',
    value: '1900000'
  },
  {
    label: '2000000',
    value: '2000000'
  }
];
const EditIcon = `
<svg width="15" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9804 1.31066C12.728 0.563113 13.94 0.563114 14.6875 1.31066C15.4351 2.05821 15.4351 3.27022 14.6875 4.01777L8.31238 10.3929C8.30084 10.4045 8.28946 10.4159 8.27822 10.4271C8.081 10.6246 7.92575 10.78 7.73961 10.8941C7.57558 10.9946 7.39675 11.0686 7.20968 11.1136C6.99741 11.1645 6.77772 11.1644 6.49864 11.1642C6.48273 11.1642 6.46663 11.1642 6.45033 11.1642H5.33397C5.05783 11.1642 4.83397 10.9404 4.83397 10.6642V9.54787C4.83397 9.53157 4.83396 9.51546 4.83395 9.49955C4.83379 9.22048 4.83366 9.00079 4.88462 8.78852C4.92953 8.60145 5.00361 8.42262 5.10413 8.25858C5.21819 8.07245 5.37363 7.9172 5.57108 7.71997C5.58233 7.70873 5.59373 7.69735 5.60526 7.68582L11.9804 1.31066ZM13.9804 2.01777C13.6234 1.66074 13.0446 1.66074 12.6875 2.01777L6.31236 8.39293C6.06493 8.64036 6.00111 8.70872 5.95677 8.78108C5.91108 8.85564 5.87741 8.93693 5.85699 9.02196C5.83718 9.10448 5.83397 9.19795 5.83397 9.54787V10.1642H6.45033C6.80025 10.1642 6.89372 10.161 6.97624 10.1412C7.06127 10.1208 7.14256 10.0871 7.21712 10.0414C7.28948 9.99707 7.35784 9.93325 7.60527 9.68582L13.9804 3.31066C14.3375 2.95364 14.3375 2.37479 13.9804 2.01777ZM4.51258 2.16421L7.33398 2.16421C7.61013 2.16421 7.83398 2.38807 7.83398 2.66421C7.83398 2.94036 7.61013 3.16421 7.33398 3.16421H4.53398C3.96568 3.16421 3.56953 3.1646 3.2611 3.1898C2.95852 3.21452 2.78468 3.26061 2.653 3.3277C2.37076 3.47151 2.14128 3.70099 1.99747 3.98323C1.93038 4.11491 1.88429 4.28875 1.85957 4.59133C1.83437 4.89976 1.83398 5.29591 1.83398 5.86421V11.4642C1.83398 12.0325 1.83437 12.4287 1.85957 12.7371C1.88429 13.0397 1.93038 13.2135 1.99747 13.3452C2.14128 13.6274 2.37076 13.8569 2.653 14.0007C2.78468 14.0678 2.95852 14.1139 3.2611 14.1386C3.56953 14.1638 3.96568 14.1642 4.53398 14.1642H10.134C10.7023 14.1642 11.0984 14.1638 11.4069 14.1386C11.7094 14.1139 11.8833 14.0678 12.015 14.0007C12.2972 13.8569 12.5267 13.6274 12.6705 13.3452C12.7376 13.2135 12.7837 13.0397 12.8084 12.7371C12.8336 12.4287 12.834 12.0325 12.834 11.4642V8.66421C12.834 8.38807 13.0578 8.16421 13.334 8.16421C13.6101 8.16421 13.834 8.38807 13.834 8.66421V11.4856C13.834 12.0275 13.834 12.4646 13.8051 12.8185C13.7753 13.183 13.7124 13.503 13.5615 13.7992C13.3218 14.2696 12.9394 14.652 12.469 14.8917C12.1728 15.0426 11.8527 15.1055 11.4883 15.1353C11.1344 15.1642 10.6973 15.1642 10.1554 15.1642H4.51257C3.97068 15.1642 3.53361 15.1642 3.17967 15.1353C2.81525 15.1055 2.49515 15.0426 2.19901 14.8917C1.7286 14.652 1.34615 14.2696 1.10647 13.7992C0.955575 13.503 0.892668 13.183 0.862894 12.8185C0.833976 12.4646 0.833979 12.0275 0.833985 11.4856V5.84281C0.833979 5.30092 0.833976 4.86384 0.862894 4.5099C0.892668 4.14548 0.955575 3.82538 1.10647 3.52924C1.34615 3.05883 1.7286 2.67638 2.19901 2.4367C2.49515 2.2858 2.81525 2.2229 3.17967 2.19312C3.53361 2.16421 3.97069 2.16421 4.51258 2.16421Z" fill="#2B244C"/>
</svg>
`

export const campaignPlaceholderMapping: { [text: string]: string } = {
  "[Job Role]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Job Role <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Company Name]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Company Name <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Client Company]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Client Company <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Your Name]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Your Name <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[mention key responsibilities or focus areas]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@mention key responsibilities or focus areas <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Job Role 1]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Job Role 1 <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Job Role 2]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Job Role 2 <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Job Role 3]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Job Role 3 <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[mention key focus areas or cutting-edge technologies]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@mention key focus areas or cutting-edge technologies <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Job role]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Job role <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Your Job Title]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Your Job Title <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Description of the first key responsibility or task]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Description of the first key responsibility or task <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Description of the second key responsibility or task]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Description of the second key responsibility or task <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Description of the third key responsibility or task]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Description of the third key responsibility or task <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[List essential qualifications, skills, and experience required for the role]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@List essential qualifications, skills, and experience required for the role <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Recruiting Agency/Consultant]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Recruiting Agency/Consultant <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[mention key responsibilities and exciting projects]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@mention key responsibilities and exciting projects <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[mention any shared experience or event]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@mention any shared experience or event <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Include a link to a video showcasing the company culture.]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Include a link to a video showcasing the company culture. <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Key Responsibility]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Key Responsibility <div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Key Responsibility 1]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Key Responsibility 1<div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Key Responsibility 2]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Key Responsibility 2<div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[Key Responsibility 3]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@Key Responsibility 3<div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[mention any exciting projects or career growth prospects]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@mention any exciting projects or career growth prospects<div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[mention their industry or field of expertise]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@mention their industry or field of expertise<div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
  "[briefly describe the impact and importance of the role]": `<span style='border: 0.1rem solid ${COLOR_MAP.WARNING_BOX}; border-radius:4px; white-space:nowrap' contenteditable='false'>@briefly describe the impact and importance of the role<div style='cursor: pointer; display: inline-block'>${EditIcon}</div></span>`,
};

export const CAMPAIGN_PLACEHOLDERS = [
  '@Job Role',
  '@Company Name',
  '@Your Name',
  '@Client Company',
  '@mention key responsibilities or focus areas',
  '@Job Role 1',
  '@Job Role 2',
  '@Job Role 3',
  '@mention key focus areas or cutting-edge technologies',
  '@Job role',
  '@Your Job Title',
  '@Description of the first key responsibility or task',
  '@Description of the second key responsibility or task',
  '@Description of the third key responsibility or task',
  '@List essential qualifications, skills, and experience required for the role',
  '@Recruiting Agency/Consultant',
  '@mention key responsibilities and exciting projects',
  '@mention any shared experience or event',
  '@Include a link to a video showcasing the company culture.',
  '@Key Responsibility',
  '@Key Responsibility 1',
  '@Key Responsibility 2',
  '@Key Responsibility 3',
  '@mention any exciting projects or career growth prospects',
  '@mention their industry or field of expertise',
  '@briefly describe the impact and importance of the role'
];


export const INITIAL_CAMPAIGN_PLACEHOLDERS = {
  '@Job Role': '',
  '@Company Name': '',
  '@Your Name': '',
  '@Client Company': '',
  '@mention key responsibilities or focus areas': '',
  '@Job Role 1': '',
  '@Job Role 2': '',
  '@Job Role 3': '',
  '@mention key focus areas or cutting-edge technologies': '',
  '@Job role': '',
  '@Your Job Title': '',
  '@Description of the first key responsibility or task': '',
  '@Description of the second key responsibility or task': '',
  '@Description of the third key responsibility or task': '',
  '@List essential qualifications, skills, and experience required for the role': '',
  '@Recruiting Agency/Consultant': '',
  '@mention key responsibilities and exciting projects': '',
  '@mention any shared experience or event': '',
  '@Include a link to a video showcasing the company culture.': '',
  '@Key Responsibility': '',
  '@Key Responsibility 1': '',
  '@Key Responsibility 2': '',
  '@Key Responsibility 3': '',
  '@mention any exciting projects or career growth prospects': '',
  '@mention their industry or field of expertise': '',
  '@briefly describe the impact and importance of the role': ''
};

export const SCHEDULED_MESSAGE_LIST = ['Automated Emails are timed throughout the day to maximise responses'];
export const BLAST_MESSAGE_LIST = ['Emails sent instantly, but candidate response rates may decrease']


export const INTEGRATE_MAIL_INFO_LIST = ['Get 3x better open & response rates','Higher Credibility of organization','Optimise to deliver on candidate active time']
